
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  components: {},
})
export default class CompareCoordinatesModal extends Vue {
    @Prop({ default: null})
    public item;

    @Prop({ default: false })
    public displayModal: boolean;

    private selectedIndex: number | null = null;
    private headers = [
      {value: "select", text: ""},
      {value: "name", text: this.$t("Buildings.name")},
      {value: "address", text: this.$t("Buildings.address")},
      {value: "zipcode", text: this.$t("Buildings.zipcode")},
      {value: "city", text: this.$t("Buildings.city")},
      {value: "registrationNumber", text: this.$t("Buildings.registrationNumber")},
      {value: "latitude", text: this.$t("form.latitude")},
      {value: "longitude", text: this.$t("form.longitude")},
    ];

    get options() {
        if (!this.item?.importValues) { return []; }

        const v = this.item.importValues;

        return Array.from({ length: v.latitudes.length }, (_, i) => ({
            index: i,
            name: v.name,
            address: v.addresses?.[i],
            zipcode: v.zipcodes?.[i],
            city: v.cities?.[i],
            registrationNumber: v.registrationNumber,
            latitude: v.latitudes?.[i],
            longitude: v.longitudes?.[i],
        }));
    }

    private validateChoice(): void {
        if (this.selectedIndex === null) { return; }
        const result = this.options[this.selectedIndex];
        this.$emit("validate", result);
        this.closeEdit();
    }

    private closeEdit(): void {
        this.selectedIndex = null;
        this.$emit("close");
    }
}
